import { useState, useCallback } from "react";
import { useIsMounted } from "./use-is-mounted.js";
import { frame } from "../frameloop/frame.js";
function useForceUpdate() {
  const isMounted = useIsMounted();
  const [forcedRenderCount, setForcedRenderCount] = useState(0);
  const forceRender = useCallback(() => {
    isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
  }, [forcedRenderCount]);
  const deferredForceRender = useCallback(() => frame.postRender(forceRender), [forceRender]);
  return [deferredForceRender, forcedRenderCount];
}
export {
  useForceUpdate
};
//# sourceMappingURL=use-force-update.js.map
